import { z } from 'zod';

export const Platform = z.enum([
  'xhs',
  'x',
  'douyin',
  'bili',
  'weibo',
  'threads',
  'youtube_shorts',
  'wechat_official_account',
]);
export type Platform = z.infer<typeof Platform>;

export const PLATFORM_DEFAULT = '_default' as const;

export const PlatformCatalogItem = z.object({
  code: Platform,
  display_name: z.string().min(1),
  is_active: z.boolean(),
  supports_text: z.boolean(),
  supports_image: z.boolean(),
  supports_video: z.boolean(),
  max_text_length: z.number().int().nonnegative().nullable(),
  max_images: z.number().int().nonnegative().nullable(),
  max_video_seconds: z.number().int().nonnegative().nullable(),
  capabilities: z.record(z.string(), z.boolean()),
  rolled_out_at: z.string().nullable(),
});
export type PlatformCatalogItem = z.infer<typeof PlatformCatalogItem>;

export const PlatformCatalogResponse = z.object({
  platforms: z.array(PlatformCatalogItem),
});
export type PlatformCatalogResponse = z.infer<typeof PlatformCatalogResponse>;

export const AdminPlatformStatusUpdateRequest = z.object({ is_active: z.boolean() }).strict();
export type AdminPlatformStatusUpdateRequest = z.infer<typeof AdminPlatformStatusUpdateRequest>;
